import { RequestParams } from '../../components/Configuration/BranchesData/BranchModal';
import Request from './request';

export default class BranchHttpService {
    private static uri = 'branches';

    public static create(branch: RequestParams) {
        return Request.post(`${this.uri}`, branch);
    }

    public static readMany(params: {
        skip?: number;
        take?: number;
        term?: string;
        cnpj?: string;
    }) {
        return Request.get(`${this.uri}`, params);
    }

    public static update(id: number, branch: RequestParams) {
        return Request.patch(`${this.uri}/${id}`, branch);
    }

    public static delete(id: number) {
        return Request.del(`${this.uri}/${id}`);
    }
}
